import type { DashboardStats } from '@/services/dashboardApi'
import { VerticalPerformanceSection } from './VerticalPerformanceSection'
import { ClosureStatsWidget } from './ClosureStatsWidget'
import UnmetDemandWidget from './UnmetDemandWidget'

export interface DashboardAnalysisPanelProps {
  stats: DashboardStats
  loading: boolean
}

/** Análisis bajo demanda: solo se monta al abrir la pestaña (sin consultas ocultas). */
export function DashboardAnalysisPanel({ stats, loading }: DashboardAnalysisPanelProps) {
  return (
    <section
      id="dashboard-panel-analysis"
      role="tabpanel"
      aria-labelledby="dashboard-tab-analysis"
      tabIndex={0}
      className="space-y-6 focus:outline-none"
    >
      <VerticalPerformanceSection stats={stats} loading={loading} />

      <section aria-label="Cierres">
        <ClosureStatsWidget />
      </section>

      <UnmetDemandWidget />
    </section>
  )
}
